import { Panel } from 'primereact/panel';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchChatDatasss, fetchDocumentsData, fetchPatientDetails, GetPat, UploadImageData, ViewDocument } from '../reduxactions/doctoractions/DoctorViewCaseActions';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DOCTOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import './DoctorViewOpenCase.css';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';

export const DoctorViewOpenCase = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const stepperRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    console.log('uid:', uid);
    console.log('id:', id);
    const getData = useSelector((state: RootState) => state.doctorviewopencase.get);
    const chatdata = useSelector((state: RootState) => state.doctorviewopencase.chat);
    const docdatass = useSelector((state: RootState) => state.doctorviewopencase.docdata);
    const pat = useSelector((state: RootState) => state.doctorviewopencase.patient);
    console.log('chatdata:', chatdata);

    useEffect(() => {
        fetchDataAsync();
        fetchchatData();
        fetchDataAsync2();
        getpt();
    }, [dispatch]);
    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchPatientDetails(uid, id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchchatData = async () => {
        try {
            console.log("dispatch");
            await dispatch(fetchChatDatasss(uid, id) as any);
        } catch (error) {
            console.log("catch");
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync2 = async () => {
        try {

            await dispatch(fetchDocumentsData(uid, id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const getpt = async () => {
        try {
            await dispatch(GetPat(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [messege, setMessage] = useState('');
    const sendChat = async () => {
        try {
            const payload = { q: 5, uid: uid, need: id, message: messege };
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname, payload);
            fetchchatData();
            setMessage('');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //view doc
    const [ViewDilog, setViewDilog] = useState(false);
    const viewdocs = useSelector((state: RootState) => state.doctorviewopencase.viewdoc);

    const viewuploaddata = (rowData: any) => {

        assignData.current = { DocID: rowData.DocID }
        setViewDilog(true);
        viewData();
    };
    const assignData = useRef({ DocID: '' });


    const viewData = async () => {
        try {
            const { DocID } = assignData.current;
            await dispatch(ViewDocument(DocID) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    const navigate = useNavigate();
    const viewPatientHis = (rowData: any) => {
        const url = `/viewpatienthistory/${rowData.PatientID}`;
        navigate(url);
    };
    const viewNotes = (rowData: any) => {
        const url = `/doctornotes/${id}`;
        navigate(url);
    };

    //add appointments
    const [addDilog, setaddDilog] = useState(false);
    const [sdate, setSdate] = useState('');
    const [Description, setDescription] = useState('');
    const [time, setTime] = useState('');
    const [duration, setDuration] = useState('');
    const toast = useRef<Toast>(null);

    const close = () => {
        setaddDilog(false);
        setAdddocument(false);
    };
    const addVolunteerDataAsync = async () => {
        if (!Description || !duration || !sdate) {
            toast.current?.show({
                severity: 'error',
                summary: 'Please fill all required fields',
                life: 3000
            });
            return;
        }

        try {
            const payload = {
                description: Description,
                duration: duration,
                need: id,
                sdate: sdate,
                stime: time,
                uid: uid,
                q: 8
            };

            const apiname = DOCTOR_API.doctorcasedetails_API;
            await LoginService.getData(apiname, payload);

            toast.current?.show({
                severity: 'success',
                summary: 'Successfully appointment added.',
                life: 3000
            });

            setaddDilog(false);
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: 'Something went wrong',
                life: 3000
            });
            console.error(error);
        }
    }
    /**
     * Author: Anuradha, Date: 2026-02-05
     * Description: function correct ga work avvatam ledu toast ravatam ledu
     */
    
    


    //upload
    const [Adddocument, setAdddocument] = useState(false);
    const [docname, setDocument] = useState<string>('');

    const imagesssss = useSelector((state: RootState) => state.doctorviewopencase.uploaddoc);
    const [selectedFile, setselectedFile] = useState<File | null>(null);

    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setselectedFile(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, id) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const Upload = async () => {
        try {
            const filename = imagesssss?.filename;
            const payload = { q: 6, uid: uid, need: id, doctitle: docname, filename: filename };
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync2();
            setAdddocument(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewdoctorcases.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="grid">
                        <div className="col-9">
                            <h2 style={{ fontWeight: '480', fontSize: '34px', marginLeft: '-45px' }}>Case Details</h2>
                        </div>

                        <div className="col-3">
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                    </div>
                    {pat[0]?.CaseStatus === 'OPEN' && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '30px', position: 'relative' }}>
                            {getData.map((response: any) => (
                                <h2 style={{ fontWeight: '380', fontSize: '24px', marginLeft: '30px' }}>Patient : {response.pfname} {response.plname}</h2>
                            ))}

                            {pat.map((rowData: any) => (
                                <h3
                                    className="patient-history-heading"
                                    style={{
                                        color: 'rgb(29, 78, 216)',
                                        fontSize: '1.2rem',
                                        fontWeight: '700',
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                    }}
                                    onClick={() => viewPatientHis(rowData)}
                                >
                                    Patient History
                                </h3>
                            ))}

                            {pat.map((rowData: any) => (
                                rowData.CaseStatus === 'OPEN' && (
                                    <div style={{ marginLeft: 'auto' }}>
                                        <Button label="Add Appointments" severity="info" style={{ marginRight: '30px', backgroundColor: 'rgb(59, 130, 246)', border: 'none', color: '#fff', padding: '17px 30px', fontSize: '18px' }} onClick={() => setaddDilog(true)} />
                                        <Button label="Notes" severity="info" style={{ marginRight: '60px', backgroundColor: 'rgb(34, 197, 94)', border: 'none', color: '#fff', padding: '17px 30px', fontSize: '18px' }} onClick={viewNotes} />
                                    </div>
                                )
                            ))}
                        </div>
                    )}
                    {pat[0]?.CaseStatus === 'CLOSE' && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '30px', position: 'relative' }}>
                            {getData.map((response: any) => (
                                <h2 style={{ fontWeight: '380', fontSize: '24px', marginLeft: '-1000px', marginBottom: '140px' }}>Patient : {response.pfname} {response.plname}</h2>
                            ))}
                            {pat.map((rowData: any) => (
                                rowData.CaseStatus === 'CLOSE' && (
                                    // <h5  style={{ float: 'left',backgroundColor: '#dc3545',color: 'white',padding: '10px',width:'160px',display: 'inline-block',fontSize:'16px',fontWeight:'500',marginTop:'30px',textAlign:'left',marginLeft:'-220px'}} key={rowData.id}>
                                    //     <i className="pi pi-ban"></i> This case was closed!
                                    // </h5>
                                    <div style={{ marginLeft: '760px', marginTop: '150px' }}>
                                        <Button label="This Case was Closed!" style={{ background: "white", color: "rgb(220, 53, 69)", border: "1px solid red", marginBottom: '15px', width: '1120px' }} className="hover-red" />
                                    </div>
                                )
                            ))}

                            {pat.map((rowData: any) => (
                                <h3
                                    className="patient-history-heading"
                                    style={{
                                        color: 'rgb(29, 78, 216)',
                                        fontSize: '1.2rem',
                                        fontWeight: '700',
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                    }}
                                    onClick={() => viewPatientHis(rowData)}
                                >
                                    Patient History
                                </h3>
                            ))}
                        </div>
                    )}

                    <section className="content">
                        <div className="grid">
                            <div className='col-9'>
                                <Panel header="Direct Chat" toggleable style={{ width: '1150px', marginTop: '-20px' }}>
                                    <Card>
                                        <div className="grid">
                                            <div className="col-12">
                                                {chatdata && chatdata.length > 0 ? (
                                                    chatdata.map((item: any, index: any) => (
                                                        <div key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                            <img
                                                                className="direct-chat-img"
                                                                src={item.photo}
                                                                alt="User Avatar"
                                                                style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px' }}
                                                            />
                                                            <div>
                                                                <span style={{ marginLeft: '-10px' }}>{item.name}</span>
                                                                <span style={{ color: 'gray', marginLeft: '6px' }}>{item.date}</span>
                                                            </div>
                                                            <p style={{ marginLeft: '35px' }}>{item.msg}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No chat data available.</p>
                                                )}
                                            </div>
                                            <div className='col-12' style={{ position: 'relative', marginTop: '20px' }}>
                                                <InputText value={messege} placeholder="Type Message ..." style={{ width: '90%', paddingRight: '5px', marginRight: '10px' }} onChange={(e) => setMessage(e.target.value)}
                                                />

                                                <Button severity="info" icon="pi pi-send" style={{ backgroundColor: 'white', color: 'green', borderRadius: '25px', border: '2px solid green' }} onClick={sendChat} />
                                            </div>
                                        </div>
                                    </Card>


                                    <Panel header="Document Uploads" toggleable>

                                        <section className="content">
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="card card-primary">
                                                        <div className="card flex flex-wrap justify-content-end">
                                                            <Button label="Upload Docs" severity="info" onClick={() => setAdddocument(true)} style={{ marginRight: '50px', background: "rgba(59,130,246,.04)", color: "#3b82f6", border: "1px solid", marginBottom: '20px' }} />
                                                        </div>
                                                        <div className="card card-primary">
                                                            <div className="card flex flex-wrap justify-content">
                                                            </div>
                                                            <DataTable value={docdatass} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                                <Column field="doc_name" sortable header="Document Title"></Column>
                                                                <Column header="Operation" body={(rowData) => (
                                                                    <>
                                                                        <Button icon="pi pi-eye" rounded outlined tooltip="View" style={{ backgroundColor: 'white', color: 'blue' }} onClick={() => viewuploaddata(rowData)} ></Button>
                                                                    </>
                                                                )} />
                                                            </DataTable>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </section>
                                    </Panel>
                                </Panel>
                            </div>
                        </div>

                    </section>

                </div>
            </div>
            {/* <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                    {viewdocs.map((response: any, index: number) =>
                        <div key={index}>
                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                        </div>
                    )}
                </div>
            </Dialog> */}
            <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                    <Button icon="pi pi-times" className="p-button-text" />
                </div>
                <div className="modal-body">
                    {viewdocs.map((response: any, index: number) =>
                        <div key={index}>
                            {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                            {response.filetype !== 'photo' &&
                                <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                            }
                            {response.filetype === 'pdf' && (
                                <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                    Open PDF in New Tab
                                </a>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            <Dialog header="Add Appointments" visible={addDilog} style={{ width: '30vw', height: '70vh' }} onHide={() => setaddDilog(false)} >

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Schedule Date:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            type='date'
                            name="Contest Name"
                            placeholder='Enter Schedule Date'
                            onChange={(e) => setSdate(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Description:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Description'
                            onChange={(e) => setDescription(e.target.value)}
                        />

                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Time:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            type='time'
                            name="Contest Name"
                            placeholder='Enter Time'
                            onChange={(e) => setTime(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Duration (In Minutes):</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Duration'
                            onChange={(e) => setDuration(e.target.value)}
                        />

                    </div>
                </div>
                <Button label="Close" onClick={close} severity="secondary" />
                <Button label="Add" onClick={addVolunteerDataAsync} style={{ float: 'right' }} />
            </Dialog >
            <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Doc Title:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            type='text'
                            value={docname}
                            name="Contest Name"
                            placeholder='Document Title'
                            onChange={(e) => setDocument(e.target.value)}
                        />
                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Select File:</label>
                    </div>
                    <div className="col-6" style={{ marginLeft: '30px' }} >
                        <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                        {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}

                    </div>
                </div>
                <Button label="Close" onClick={close} severity="secondary" />
                <Button label="Add" onClick={Upload} style={{ float: 'right' }} />

            </Dialog>
            <Toast ref={toast} />



        </div>

    )
}